__turbopack_context__.v({
  "canvasContainer": "_3qmODq_canvasContainer",
  "caption": "_3qmODq_caption",
  "ctaContainer": "_3qmODq_ctaContainer",
  "mainContent": "_3qmODq_mainContent",
  "primary": "_3qmODq_primary",
  "root": "_3qmODq_root",
});
